import React, { useState, useEffect, useRef } from 'react'
import * as XLSX from 'xlsx'
import { makeStyles } from '@material-ui/core/styles'
import useUsersApi from '../../hooks/users/useUsersApi'
import { Button, Modal } from '@material-ui/core'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

import InvitationsForm from './InvitationsForm'
import useBuildingsApi from '../../hooks/buildings/useBuildingsApi'
import useApartmentsApi from '../../hooks/apartments/useApartmentsApi'
import useDebounce from '../../hooks/useDebounce'
import DeleteConfirmationModal from '../common/DeleteConfirmationModal'
import CustomTable from '../customTable/CustomTable'
import ListHeader from '../common/ListHeader'

export default function InvitationsList({ type }) {
  const classes = useStyles()
  const history = useHistory()
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [modalOpen, setModalOpen] = useState(false)
  const [selectedInvitation, setSelectedInvitation] = useState(null)

  const inputRef = useRef()
  const [{ invitedUsersState }, methods] = useUsersApi()

  const [selectedBuilding, setSelectedBuilding] = useState(false)
  const [selectedApartment, setSelectedApartment] = useState(null)
  const [search, setSearch] = useState('')
  const [{ buildingsState }, { getBuildings }] = useBuildingsApi()
  const [
    { getApartmentsFromBuildingState, apartmentsState },
    { getApartmentsFromBuilding, getApartments },
  ] = useApartmentsApi()

  const onSearchChangeDebounced = useDebounce((value) => {
    setSearch(value)
  }, 600)

  useEffect(() => {
    const fetchData = async () => {
      getBuildings()
      getApartments()
    }
    fetchData()
  }, [])

  useEffect(() => {
    if (selectedBuilding) {
      setSelectedApartment(null)
      const fetchApartmentsFromBuilding = async () => {
        getApartmentsFromBuilding(selectedBuilding.id)
      }
      fetchApartmentsFromBuilding()
    }
  }, [selectedBuilding?.id])

  useEffect(() => {
    const fetchData = async (params) => {
      methods.getInvitedUsers(params)
    }
    let params = {}
    if (selectedBuilding?.id) params.buildingId = selectedBuilding?.id
    if (selectedApartment?.id) params.apartmentId = selectedApartment?.id
    if (search) params.search = search
    fetchData(params)
  }, [selectedBuilding, selectedApartment, search])

  const columns = [
    { id: 'name', label: 'Nombre', minWidth: 170 },
    { id: 'surname', label: 'Apellido', minWidth: 170 },
    {
      id: 'email',
      label: 'Email',
      minWidth: 170,
    },
    {
      id: '',
      label: '',
      minWidth: 5,
    },
  ]

  // useEffect(() => {
  //   const fetchData = async () => {
  //     methods.getInvitedUsers()
  //   }
  //   fetchData()
  // }, [])

  const handleChangePage = (newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  const options = (invitation) => [
    {
      key: 'resend',
      label: 'Reenviar',
      onClick: () => {
        methods.resendInvitation(invitation.id)
      },
    },
    {
      key: 'delete',
      label: 'Eliminar',
      onClick: () => {
        setSelectedInvitation(invitation)
      },
    },
  ]

  const handleSelectFile = (event) => {
    event.preventDefault()

    var files = event.target.files,
      f = files[0]
    var reader = new FileReader()
    reader.onload = (e) => {
      var data = e.target.result
      let readedData = XLSX.read(data, { type: 'binary' })
      const wsname = readedData.SheetNames[0]
      const ws = readedData.Sheets[wsname]

      const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 })
      methods.sendInvitations(dataParse.slice(1))
    }
    reader.readAsBinaryString(f)
  }

  const invitations = invitedUsersState.data.invitations

  return (
    <>
      {/* <Paper className={classes.root}> */}
      {/* <div className={classes.buttonsContainer}>
        <Button
          onClick={() => inputRef.current.click()}
          variant="contained"
          color="primary"
        >
          Subir archivo
        </Button>
        <Button
          className={classes.buttonsMargin}
          variant="outlined"
          onClick={() => history.push('nueva-invitacion')}
        >
          Agregar
        </Button>
      </div> */}
      <ListHeader bigTitle="Invitaciones" canCreate={false} />
      <CustomTable
        columns={columns}
        data={invitations}
        options={options}
        page={page}
        rowsPerPage={rowsPerPage}
        searchTitle={'Nombre, apellido o Email'}
        searchPlaceholder={'Ingrese un nombre, apellido o Email'}
        buildingFilter
        apartmentFilter
        getData={methods.getInvitedUsers}
      />
      <input
        id="btn-upload"
        name="btn-upload"
        style={{ display: 'none' }}
        type="file"
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        ref={inputRef}
        onChange={handleSelectFile}
      />
      <DeleteConfirmationModal
        open={!!selectedInvitation}
        invitation={selectedInvitation}
        onClose={() => setSelectedInvitation(null)}
        onDelete={(invitation) => {
          methods.deleteInvitation(invitation.id)
          setSelectedInvitation(null)
        }}
      />
    </>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  container: {
    maxHeight: '80vh',
  },
  addButton: {
    position: 'absolute',
    right: '32px',
    bottom: '32px',
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    backgroundColor: '#303030',
    paddingBottom: '10px',
  },
  buttonsMargin: {
    marginLeft: '24px',
  },
  searchWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '20px',
  },
}))
